import { getEnv } from 'global/helpers/environment'
import type { FaqCategory, TheHulkMessageProps } from 'modules/TheHulk/TheHulk.types'

export const cleanHTML = (html: string): string => {
  return html.replaceAll(/<[^>]*>?/g, '')
}

export const setTheHulkMessageRead = (message: string) => {
  const readMessages = JSON?.parse(localStorage.getItem('theHulkReadMessages') ?? '[]') as string[]
  // Update the array with the new message key
  const updatedReadMessages = [...readMessages, message]
  // Store the updated array back into localStorage
  localStorage.setItem('theHulkReadMessages', JSON.stringify(updatedReadMessages))
}

export const hulkSmash = (activeMessages: TheHulkMessageProps[], placement: string): TheHulkMessageProps | null => {
  const environment = getEnv()
  if (!activeMessages) {
    return null
  }

  const storedMessages = localStorage.getItem('theHulkReadMessages')
  const readMessages = storedMessages ? (JSON.parse(storedMessages) as string[]) : []
  const unreadMessages = activeMessages.filter((message) => !readMessages.includes(message.key))

  // environment filtering for the messages
  const envFilteredMessages = unreadMessages.filter(message =>
    message.tags.split(',').map(tag => tag.trim().toLowerCase()).filter(tag => tag.length > 0).includes(environment))

  // placement on page filtering
  const placementFilteredMessages = envFilteredMessages.filter(message => message.tags
    .split(',')
    .map(tag => tag.trim().toLowerCase())
    .filter(tag => tag.length > 0)
    .some(t => [placement, 'global'].includes(t)),
  )
  if (placementFilteredMessages.length === 0) {
    return null
  }

  const cleanedContent = cleanHTML(placementFilteredMessages[0]!.content)
  return { ...placementFilteredMessages[0]!, content: cleanedContent }
}

export const filterHulkCategories = (categories: FaqCategory[]): FaqCategory[] | null => {
  if (!categories) {
    return null
  }

  const validCategories = categories.filter((category) => category.name !== 'Announcements')
  const defaultLanguage = 'en'
  const userLanguage = localStorage.getItem('userLanguage') ?? localStorage.getItem('i18nextLng') ?? defaultLanguage
  const translatedCategories = validCategories.filter((category) => category.key.endsWith(userLanguage))
  if (translatedCategories.length > 0) {
    return translatedCategories
  }
  return validCategories.filter((category) => category.key.endsWith(defaultLanguage))
}

export const cleanHulkQuestions = (questions: TheHulkMessageProps[]): TheHulkMessageProps[] | null => {
  if (!questions) {
    return null
  }
  for (const question of questions) {
    question.content = cleanHTML(question.content)
  }
  return questions.reverse()
}
